module.exports = __webpack_public_path__ + "img/personal_color.66276340.png";